<div class="card card--widget is-fullheight" *ngIf="countries">
  <div class="card-content">
    <div
      class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
    >
      <div
        class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
      >
        <p class="has-text-weight-bold mt-2 mb-4 has-text-light">
          Country comparison widget
        </p>

        <form
          [formGroup]="countryForm"
          class="is-flex is-align-items-flex-start is-justify-content-flex-start is-fullwidth"
        >
          <div class="is-flex is-align-items-center is-justify-content-center">
            <div class="select is-small is-fullwidth mb-2 mr-2">
              <select formControlName="country1">
                <option
                  *ngFor="let country of countries"
                  [value]="country.label"
                >
                  {{ country.label }}
                </option>
              </select>
            </div>
            <div class="select is-small is-fullwidth mb-2">
              <select formControlName="country2">
                <option
                  *ngFor="let country of countries"
                  [value]="country.label"
                >
                  {{ country.label }}
                </option>
              </select>
            </div>
          </div>

          <a
            [routerLink]="['/incentives']"
            [queryParams]="{
              'f:Country': [
                countryForm.value.country1,
                countryForm.value.country2
              ]
            }"
            class="button is-small is-link"
            >Compare tax incentives
          </a>
        </form>
      </div>
    </div>
  </div>
</div>
